import { HttpBackend } from '@angular/common/http';
import { ITranslationResource, MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { Observable, tap } from 'rxjs';

const TRANSLATIONS_LOCAL_STORAGE_KEY = 'Translations';

export class TranslationsLoader {
  private loader: MultiTranslateHttpLoader;

  constructor(private httpBackend: HttpBackend, private resources: ITranslationResource[], private version: string) {
    this.loader = new MultiTranslateHttpLoader(this.httpBackend, this.resources);
  }

  getTranslation(lang: string): Observable<unknown> {
    const key: string = `${TRANSLATIONS_LOCAL_STORAGE_KEY}:${lang}:${this.version}`;
    const storedTranslations: string | null = localStorage.getItem(key);
    if (storedTranslations) {
      return new Observable(observer => {
        observer.next(JSON.parse(storedTranslations));
        observer.complete();
      });
    } else {
      return this.loader.getTranslation(lang).pipe(tap((translations) => {
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (key && key.startsWith(TRANSLATIONS_LOCAL_STORAGE_KEY) && !key.endsWith(this.version)) {
            localStorage.removeItem(key);
          }
        }
        localStorage.setItem(key, JSON.stringify(translations));
      }));
    }
  }
}
